import React, { useEffect, useState } from 'react';
import { editarPdv, obterPdvPorId, atualizarModulosLicenca } from '../services/api';
import CadastroPdv from './CadastroPdv';
import { useParams, useNavigate } from 'react-router-dom';

const EditarPdv = ({ token }) => {
  const [initialData, setInitialData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await obterPdvPorId(id, token);
        setInitialData(response.data);
      } catch (error) {
        console.error('Erro ao carregar os dados do PDV:', error);
      }
    };
    fetchData();
  }, [id, token]);

  const handleEditSubmit = async (data, token, { itensModulos = [] } = {}) => {
    try {
      await editarPdv(id, data, token);
      if (itensModulos.length > 0) {
        await atualizarModulosLicenca('ZenPDV', Number(id), itensModulos, token);
      }
      alert('PDV atualizado com sucesso!');
      navigate('/licenciamento/zenpdv');
    } catch (error) {
      console.error('Erro ao atualizar PDV:', error);
      throw error;
    }
  };

  if (!initialData) {
    return <div>Carregando...</div>;
  }

  return (
    <CadastroPdv
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
      licencaId={Number(id)}
    />
  );
};

export default EditarPdv;
